"use client";

import { SpatiusAvatarProvider } from "@/components/spatius-avatar";
import type { SpatiusPrimarySession } from "@/hooks/useLiveKitAgent";
import { RoomContext } from "@livekit/components-react";
import type { Room } from "livekit-client";
import type { ReactNode } from "react";

interface SpatiusPrimarySessionRootProps {
  baseRoom: Room;
  children: ReactNode;
  onConnected: (room: Room | null) => void;
  onDisconnected: () => void;
  onError: (error: Error) => void;
  onStateChange?: (
    status: "idle" | "initializing" | "connecting" | "connected" | "disconnecting" | "error"
  ) => void;
  session: SpatiusPrimarySession | null;
}

export function SpatiusPrimarySessionRoot({
  baseRoom,
  children,
  onConnected,
  onDisconnected,
  onError,
  onStateChange,
  session,
}: SpatiusPrimarySessionRootProps) {
  if (!session) {
    return <RoomContext.Provider value={baseRoom}>{children}</RoomContext.Provider>;
  }

  return (
    <SpatiusAvatarProvider
      appId={session.spatius.appId}
      avatarId={session.spatius.avatarId}
      connection={session.connection}
      enabled={true}
      onAvatarError={onError}
      onConnected={onConnected}
      onDisconnected={onDisconnected}
      onStateChange={onStateChange}
      publishMicrophone={false}
      region={session.spatius.region}
      sessionToken={session.spatius.sessionToken}
    >
      <RoomContext.Provider value={baseRoom}>{children}</RoomContext.Provider>
    </SpatiusAvatarProvider>
  );
}
